import { render, staticRenderFns } from "./esgreport.vue?vue&type=template&id=b7c27a5c&scoped=true&"
import script from "./esgreport.vue?vue&type=script&lang=js&"
export * from "./esgreport.vue?vue&type=script&lang=js&"
import style0 from "./esgreport.vue?vue&type=style&index=0&id=b7c27a5c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7c27a5c",
  null
  
)

export default component.exports